import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest';

const AGENT_LANDING_ROUTER_NAME = 'agent-landing';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: AGENT_LANDING_ROUTER_NAME,
    exclusiveRoutePath: '/agent-landing/:type?',
    getComponent: () => import('./AgentLanding.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        executeCommand(
            commandId: 'command:route:agent-landing',
            params?: { type?: 'novelty' | 'fto' | 'design-fto' }
        ): void;
    }
}
